module.exports = __webpack_public_path__ + "img/parceiro_robotz.7677d11b.png";